<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "TagList" });
import Tag from "../tag/Tag.svelte";
import Legend from "../../elements/legend/Legend.svelte";
import LabelError from "../../elements/label-error/LabelError.svelte";
import "tailwindcss/tailwind.css";
import { handleInputError } from "../../common/validation.js";
export let keys;
export let options = [];
export let label = void 0;
export let minItems = 0;
export let maxItems = 100;
export let isDisabled = false;
export let mode = "remove";
export let css = "";
export let name = "";
const onRemove = (event) => {
    keys = keys.filter((key) => key !== event.detail.key);
};
const onAdd = (event) => {
    keys = [...keys, event.detail.key];
};
const showTag = (key, keys2) => {
    if (mode === "add" && !keys2.includes(key)) {
        return true;
    }
    if (mode === "remove" && keys2.includes(key)) {
        return true;
    }
    if (mode === "toggle") {
        return true;
    }
    return false;
};
const getMode = (key, keys2, mode2) => {
    if (mode2 !== "toggle") {
        return mode2;
    }
    if (Array.isArray(keys2) && keys2.includes(key)) {
        return "remove";
    }
    return "add";
};
const getDisabled = (option, isDisabled2, keys2) => {
    if (isDisabled2) {
        return true;
    }
    if (option.isDisabled === true) {
        return true;
    }
    if (!Array.isArray(keys2)) {
        return false;
    }
    if (maxItems !== void 0 && keys2.length >= maxItems && !keys2.includes(option.key)) {
        return true;
    }
    return false;
};
const checkLabelVisibility = (label2, mode2, keys2, options2) => {
    const OPTION_KEYS = options2.map((option) => option.key);
    if (label2 === void 0) {
        return false;
    }
    if (label2 === null) {
        return false;
    }
    if (mode2 === "add" && OPTION_KEYS.every((key) => keys2.includes(key))) {
        return false;
    }
    return true;
};
$: isLabelVisible = checkLabelVisibility(label, mode, keys, options);
let error = null;
const validate = (event) => {
    const TARGET = event.target;
    error = handleInputError(TARGET);
};
const setValidation = (keys2, maxItems2, minItems2) => {
    const COUNT = Array.isArray(keys2) ? keys2.length : 0;
    if (maxItems2 !== void 0 && COUNT > maxItems2) {
        return "max_items";
    }
    if (minItems2 !== void 0 && COUNT < minItems2) {
        return "min_items";
    }
    error = null;
    return "";
};
$: validation = setValidation(keys, maxItems, minItems);
</script>

{#if Array.isArray(options) && options.length > 0}

    <div class = 's8-tag-list s8-form-row'>

        {#if isLabelVisible}
            <Legend { label } { isDisabled }/>
        {/if}

        <ul class = { `s8-tags ${ css }` } >
            {#each options as option }
                {#if showTag(option.key, keys) }
                    <li>
                        <Tag
                            key = { option.key }
                            isDisabled = { getDisabled(option, isDisabled, keys) }
                            mode = { getMode(option.key, keys, mode) }
                            on:remove = { onRemove }
                            on:add = { onAdd }
                        >
                            { option.label }
                        </Tag>
                    </li>
                {/if}
            {/each}
        </ul>

        <div class = 's8-footer'>
            <LabelError { error } />
        </div>

        <input
            type = 'hidden'
            data-custom-validation = { validation }
            on:invalid = { validate }
            name = { `hidden-${ name }`}
        />

    </div>
{/if}

<style>

    div.s8-tag-list {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        row-gap: 2px;
        margin-bottom: 16px;
    }

        div.s8-tag-list ul.s8-tags {
            flex-wrap: wrap;
            gap: 5px;
            display: flex;
        }

        div.s8-tag-list div.s8-footer {
            min-height: 10px;
        }</style>